import { Component, OnInit } from '@angular/core';
import { PopupConfigService } from './popup-config.service';
import { MainContainerService } from '../main-container/main-container.service';
import { NotificationService } from '../shared/notification.service';
import { MotoristaConfig } from './model/motoristaConfig.model';
import { UsuarioOcorrencia } from './model/usuarioOcorrencia.model';
import { UsuarioOcMotor } from './model/usuarioOcMotor.models';
import { JsonReturn, ObjectParam } from '../interface/generic-interface';

declare var jquery: any;
declare var $: any;

@Component({
  standalone: false,
  selector: 'popup-config',
  templateUrl: './popup-config.component.html',
  styleUrls: ['./popup-config.component.css']
})
export class PopupConfigComponent implements OnInit {

  vetListaStatusFinalizacaoVerificar: any[];
  vetListaTipoRecusaVerificar: any[];
  public descricaoMotivo = '';
  ckbFiltroAvancado = false;
  public msgValidacaoDescMotivo: string;
  public listMotivos: any[];
  public listVoltoDepois: any[];
  public msgValidacao = '';
  public statusFinalizacao = '';
  public tipoRecusa = '';
  public tipoVoltoDepois = '';
  public nomeAtendente = '';
  public ckd_ativo = 'S';
  public ckd_tipoRecusa = true;
  public ckd_confFiltroAtivo = true;
  public ckd_tipoVoltoDepois = true;
  public ckd_tipoOc = true;
  configuracoes = [];
  motoristas: Array<MotoristaConfig> = []
  motoristasFiltro: Array<MotoristaConfig> = []
  usuariosOcorrencia: Array<UsuarioOcorrencia> = []
  usuarioOcMotor: Array<UsuarioOcMotor> = []
  modoEdicao = false;
  modoEdicaoMotivo = false;
  modoEdicaoFinalizacao = false;
  modoEdicaoTipoRecusa = false;
  modoEdicaoVoltoDepois = false;
  usuarioEdicaoAtual: UsuarioOcorrencia = null;
  motivoEdicaoAtual: any = null;
  finalizacaoEdicaoAtual: any = null;
  tipoRecusaEdicaoAtual: any = null;
  voltoDepoisEdicaoAtual: any = null;

  //Campo filtros 
  descricaoFiltroMotivo = '';
  descricaoFiltroFinalizacao = '';
  descricaoFiltroTipoRecusa = '';
  descricaoFiltroVoltoDepois = '';



  constructor(
    public popupConfigService: PopupConfigService,
    private mainContainerService: MainContainerService,
    private notificationService: NotificationService
  ) { }

  async ngOnInit() {
    await this.listMotivo();
    await this.listaStatusFinalizacao();
    await this.listaTipoRecusa();
    await this.listaTipoVoltoDepois();
    await this.listUsuarioOcMotor();
    await this.getMotoristas();
    await this.listaUsuariosOcorrencia();

    await this.getConfiguracoesGerais()

  }
  

  async cadastrarMotivo() {

    if(this.modoEdicaoMotivo){
      this.onEditMotivo(this.motivoEdicaoAtual.IdMotivo)
    }else{
      this.mainContainerService.loadingProcessando = true;
      let resultValidacao = await this.validaCadastrarMotivo();
      if (Boolean(resultValidacao) === true) {
        const objParam : ObjectParam = {
          motivoOcorrencia : {
                Descricao: this.descricaoMotivo,
                Ativa: this.ckd_tipoOc
          }
        }
        try {
          const response = await this.popupConfigService.postCadastraMotivo(objParam)
  
          if(response.sucesso){
            this.descricaoMotivo = '';
            await this.listMotivo();
          }
        
        } catch (Error) {
            console.log("CATCH________cadastrarMotivo");
            console.log(Error);
        }
        finally{
          this.mainContainerService.loadingProcessando = false;
        }
      }
    }
  }

  async validaCadastrarMotivo() {
    let validacao = true;
    if (this.descricaoMotivo === null || this.descricaoMotivo === undefined) {
      this.msgValidacaoDescMotivo = '*Descrição do Motivo obrigatório';
      validacao = false;
    }else {
      this.msgValidacaoDescMotivo = '';
    }
    for (let i = 0; i < this.listMotivos.length; i++) {
      if ( String(this.listMotivos[i].Descricao.toUpperCase()) === String(this.descricaoMotivo.toUpperCase()) ) {
        this.msgValidacaoDescMotivo = '*Motivo já cadastrado!';
        validacao = false;
        this.mainContainerService.loadingProcessando = false;
        break;
      }
    }
    return Boolean(validacao);
  }

  async listMotivo() {
    let response = await this.popupConfigService.getListMotivos();
    response = response.map((motivo) => {
      motivo.Ativa = motivo.Ativa? 'Sim' : 'Não'
      return motivo;
    })
    this.listMotivos = response;
    this.listMotivos = this.listMotivos.filter((element) => !element.Descricao.includes('- OC Aut'))
  }

  async onSaveStatusConfirm(finalizacao) 
  {
    this.mainContainerService.loadingProcessando = true;
    const retorno = await this.popupConfigService.putCadastraStatusFinalizacao(finalizacao.IdStatusFinalizacao, this.statusFinalizacao, this.ckd_ativo);
    if(retorno.sucesso) {
      await this.listaStatusFinalizacao();
      this.cancelarEdicaoFinalizacao();
    }
    this.mainContainerService.loadingProcessando = false;
  }

  async cadastrarStatusFinalizacao() 
  {
    if(this.modoEdicaoFinalizacao){
      this.onSaveStatusConfirm(this.finalizacaoEdicaoAtual)
    }else{

      try 
      {
        this.mainContainerService.loadingProcessando = true;
        this.msgValidacao = '';
        this.statusFinalizacao === '' ? this.msgValidacao = 'Favor informar a descrição!' : this.msgValidacao = '';
  
        if (this.statusFinalizacao !== '') 
        {
          const statusCadastrado = this.vetListaStatusFinalizacaoVerificar;
  
          for (let i = 0; i < statusCadastrado.length; i++) 
          {
            if (String(statusCadastrado[i].Descricao) === String(this.statusFinalizacao.toLocaleUpperCase())) 
            {
              this.msgValidacao = 'Status já cadastrado!';
              break;
            }
          }
  
          if (this.msgValidacao === '') 
          {
            const retorno = await this.popupConfigService.postCadastraStatusFinalizacao(this.statusFinalizacao, this.ckd_ativo);
            await this.listaStatusFinalizacao();
  
            this.statusFinalizacao = '';
            this.ckd_ativo = 'S';
  
            if(retorno.sucesso) this.notificationService.showSucesso('Cadastro realizado com sucesso!');          
          }
        }
      } catch (e) {
          console.log("CATCH________cadastrarStatusFinalizacao");
          console.log(e);
      }
      finally{
        this.mainContainerService.loadingProcessando = false;
      }
    }
  }  

  async listaStatusFinalizacao() 
  {
    let listStatusFinalizacao = [];

    const response = await this.popupConfigService.getListaStatusFinalizacao();
    this.vetListaStatusFinalizacaoVerificar = response;

    for (let i = 0; i < response.length; i++) 
    {
      if (String(response[i].Ativo) === 'S') 
      {
        listStatusFinalizacao.push(response[i]);
      }

      response[i].Ativo = response[i].Ativo === "S" ? "Sim" : "Não";
    }

    this.popupConfigService.vetListaStatusFinalizacao = [];
    this.popupConfigService.vetListaStatusFinalizacao = listStatusFinalizacao; 
  }

  async alteraStatus(e) {
    if (this.ckd_ativo === 'N') {
      this.ckd_ativo = 'S';
    }else {
      this.ckd_ativo = 'N';
    }
  }
  
  async alteraTipoRecusa(e) {
    if (this.ckd_tipoRecusa) {
      this.ckd_tipoRecusa = false
    }else {
      this.ckd_tipoRecusa = true
    }
  }

  async alteraTipoVoltoDepois(e) {
    if (this.ckd_tipoRecusa) {
      this.ckd_tipoVoltoDepois = false
    }else {
      this.ckd_tipoVoltoDepois = true
    }
  }


  alteraConfigFiltorAtivo() {
    this.ckd_confFiltroAtivo = !this.ckd_confFiltroAtivo;
  }

  async alteraTipoOc(e) {
    if (this.ckd_tipoOc) {
      this.ckd_tipoOc = false
    }else {
      this.ckd_tipoOc = true
    }
  }

  async listaTipoRecusa() 
  {
    let listTipoRecusa = [];

    let response = await this.popupConfigService.getListaTipoRecusa();
    this.vetListaTipoRecusaVerificar = response;
    
    response = response.map((tipoRecusa) => {
      tipoRecusa.Ativa = tipoRecusa.Ativa? 'Sim' : 'Não'
      return tipoRecusa
    })


    this.popupConfigService.vetListaTipoRecusa = [];
    this.popupConfigService.vetListaTipoRecusa = response;

    
    
  }

  async listaTipoVoltoDepois() 
  {  
    let response = await this.popupConfigService.getListaTipoVoltoDepois();  
    
    response = response.map((tipoVoltoDepois) => {
      tipoVoltoDepois.Ativa = tipoVoltoDepois.Ativa? 'Sim' : 'Não'
      return tipoVoltoDepois
    })
    this.listVoltoDepois = response;
    
  }

  async cadastrarTipoRecusa(){
    this.mainContainerService.loadingProcessando = true;
    let contemDescricao = this.vetListaTipoRecusaVerificar.some((tipoRecusa) => tipoRecusa.Descricao.toUpperCase() == this.tipoRecusa.toUpperCase());    
    if(contemDescricao && !this.modoEdicaoTipoRecusa){
      this.msgValidacao = 'Recusa já cadastrada!';
    }
    else if(this.modoEdicaoTipoRecusa){
      this.onEditTipoRecusa(this.tipoRecusaEdicaoAtual.IdTipoRecusa)
      this.msgValidacao = ''
    }
    else{
      this.msgValidacao = '';
      const retorno = await this.popupConfigService.postCadastraTipoRecusa(this.tipoRecusa, this.ckd_tipoRecusa);
      if(retorno.sucesso){
        await this.listaTipoRecusa();
        this.notificationService.showSucesso('Cadastro realizado com sucesso!')
        this.tipoRecusa = '';
      }
    }
    this.mainContainerService.loadingProcessando = false;
  }

  async cadastrarTipoVoltoDepois(){
    this.mainContainerService.loadingProcessando = true;
    let contemDescricao = this.listVoltoDepois.some((voltoDepois) => voltoDepois.Descricao.toUpperCase() == this.tipoVoltoDepois.toUpperCase());    
    if(contemDescricao && !this.modoEdicaoVoltoDepois){
      this.msgValidacao = 'Volto Depois já cadastrada!';
    }
    else if(this.modoEdicaoVoltoDepois){
      this.msgValidacao = '';
      this.onEditTipoVoltoDepois(this.voltoDepoisEdicaoAtual.IdTipoVoltoDepois)
    }
    else{
      this.msgValidacao = '';
      const retorno = await this.popupConfigService.postCadastraTipoVoltoDepois(this.tipoVoltoDepois, this.ckd_tipoRecusa);
      if(retorno.sucesso){
        await this.listaTipoVoltoDepois();
        this.notificationService.showSucesso('Cadastro realizado com sucesso!')
        this.tipoVoltoDepois = '';
      }
    }
    this.mainContainerService.loadingProcessando = false;
  }

  async onEditTipoRecusa(idTipoRecusa: number){
  
    this.mainContainerService.loadingProcessando = true;
    const retorno = await this.popupConfigService.atualizarTipoRecusa(idTipoRecusa, this.tipoRecusa, this.ckd_tipoRecusa);
    if(retorno.sucesso){  
      await this.listaTipoRecusa();
      this.notificationService.showSucesso('Atualizado com sucesso!') 
      this.cancelarEdicaoTipoRecusa();
    }
    this.mainContainerService.loadingProcessando = false;
  } 

  async onEditTipoVoltoDepois(idTipoVoltoDepois){
    this.mainContainerService.loadingProcessando = true;
    const retorno = await this.popupConfigService.atualizarTipoVoltoDepois(idTipoVoltoDepois , this.tipoVoltoDepois, this.ckd_tipoVoltoDepois);
    if(retorno.sucesso){  
      await this.listaTipoVoltoDepois();
      this.notificationService.showSucesso('Atualizado com sucesso!')
      this.cancelarEdicaoVoltoDepois()  
    }
    this.mainContainerService.loadingProcessando = false;
  } 

  async onEditMotivo(idMotivo: number){
    this.mainContainerService.loadingProcessando = true;
    const retorno = await this.popupConfigService.atualizarMotivoOc(idMotivo, this.descricaoMotivo, this.ckd_tipoOc);
    if(retorno.sucesso){  
      await this.listMotivo();
      this.notificationService.showSucesso('Atualizado com sucesso!')
      this.cancelarEdicaoMotivo();
    }
    this.mainContainerService.loadingProcessando = false;
  } 

 

 

  alteraConfFiltroAvancado(){
    this.ckbFiltroAvancado = !this.ckbFiltroAvancado;
    let configuracao =  this.configuracoes.find((conf) => conf.Nome == 'RecursoFiltroAvancadoOC');
    configuracao.Valor = this.ckbFiltroAvancado? '1': '0';
    let objParam: ObjectParam = {
      configuracaoGeral : configuracao
    }
    this.popupConfigService.updateConfiguracaoGeral(configuracao.ConfiguracaoGeralID, objParam)
    this.popupConfigService.filtroAvancadoAtivo = this.ckbFiltroAvancado;
    this.popupConfigService.filtraRoteirosTela()
  }


  async getMotoristas(){
    this.motoristas = await this.popupConfigService.getMotoristas();
    this.popupConfigService.motoristasFiltro = await this.popupConfigService.getMotoristas();
    this.marcarTodosMotor()
  }

  async getConfiguracoesGerais(){
    this.configuracoes = await this.popupConfigService.getConfiguracoesGerais();
    let resultado = this.configuracoes.find((conf) => conf.Nome == 'RecursoFiltroAvancadoOC').Valor ?? '0';
    this.ckbFiltroAvancado = resultado == '1'? true : false;
    this.popupConfigService.filtroAvancadoAtivo = this.ckbFiltroAvancado

    if(this.popupConfigService.filtroAvancadoAtivo){
      this.popupConfigService.filtraRoteirosTela()
    }
  }

  alterarCheckedMotor(cdMotor: string) {
    const motorista = this.motoristas.find(m => m.CdMotor === cdMotor);
    if (motorista) {
      motorista.checked = !motorista.checked;
    }
  }

  async listaUsuariosOcorrencia() 
  {  
    this.usuariosOcorrencia = await this.popupConfigService.getListaUsuarioOcorrencia();  
    this.usuariosOcorrencia.forEach((usuario) => {
      usuario.motoristas = this.usuarioOcMotor.filter((usuaOcMotor) => usuaOcMotor.UsuariosMotOCID == usuario.UsuariosMotOcID)
      return usuario
    })

    this.popupConfigService.usuariosOcorrencia = this.usuariosOcorrencia;
    this.popupConfigService.motoristas = this.motoristas

    this.popupConfigService.atualizaUsuariosChecked()


  }

  async listUsuarioOcMotor() 
  {  
    this.usuarioOcMotor = await this.popupConfigService.getUsuarioOcMotor();  
  }

  async cadastrarFiltroAvancado(){
    this.mainContainerService.loadingProcessando = true;
    let contemUsuario = this.usuariosOcorrencia.some((usuario) => usuario.Usuario.toUpperCase() == this.nomeAtendente.toUpperCase());    
    if(contemUsuario && !this.modoEdicao){
      this.msgValidacao = 'Atendente já cadastrado!';
    }
    else{
      this.msgValidacao = '';
      let objParam: ObjectParam = {
        usuariosOcorrencia : {
          Usuario: this.nomeAtendente,
          Ativo: this.ckd_confFiltroAtivo
        }   
      }

      let retorno: JsonReturn = null;
      let motorSelecionados = this.motoristas.filter((motor) => motor.checked);
      let listCdMotor = motorSelecionados.map((motor)=> motor.MotorID);

      let usuariosMotOcID = null;
      
      if(this.modoEdicao){
        retorno = await this.popupConfigService.putCadastrUsuarioOcorrencia(this.usuarioEdicaoAtual.UsuariosMotOcID, objParam);         
        usuariosMotOcID = this.usuarioEdicaoAtual.UsuariosMotOcID;

      }else{
        retorno = await this.popupConfigService.postCadastrUsuarioOcorrencia(objParam);
        usuariosMotOcID = retorno.response[0].UsuariosMotOcID;
      }

      if(retorno.sucesso){
      
        let objParam: ObjectParam = {
          usuarioOcMotor : {
            UsuariosMotOCID: usuariosMotOcID,
            listMotorID : listCdMotor
          }
        }

        await this.atualizaUsuarioOcMotor(objParam)      
        await this.listUsuarioOcMotor();  
        await this.listaUsuariosOcorrencia();
        this.popupConfigService.filtraRoteirosTela()
        this.notificationService.showSucesso(`Atendente ${this.modoEdicao? 'editado': 'cadastrado' } com sucesso!`)
        this.cancelarEdicao();
      }
    }
    this.mainContainerService.loadingProcessando = false;
  }


  alteraModoEdicao(usuario){
    this.modoEdicao = true;
    this.usuarioEdicaoAtual = usuario;
    this.nomeAtendente = this.usuarioEdicaoAtual.Usuario ;
    this.ckd_confFiltroAtivo = this.usuarioEdicaoAtual.Ativo;
    this.desmarcarTodosMotor();
    this.marcarMotorUsuario();
  }

  alteraModoEdicaoMotivo(motivo){
    this.modoEdicaoMotivo = true;
    this.motivoEdicaoAtual = motivo;
    this.descricaoMotivo = this.motivoEdicaoAtual.Descricao ;
    this.ckd_tipoOc = this.motivoEdicaoAtual.Ativa == 'Sim'? true: false;
  }

  cancelarEdicaoMotivo(){
    this.modoEdicaoMotivo = false;
    this.motivoEdicaoAtual = null;
    this.descricaoMotivo = '' ;
    this.ckd_tipoOc = true;
  }


  alteraModoEdicaoFinalizacao(finalizacao){
    this.modoEdicaoFinalizacao = true;
    this.finalizacaoEdicaoAtual = finalizacao;
    this.statusFinalizacao = this.finalizacaoEdicaoAtual.Descricao ;
    this.ckd_ativo = this.finalizacaoEdicaoAtual.Ativo? 'S': 'N';
  }

  cancelarEdicaoFinalizacao(){
    this.modoEdicaoFinalizacao = false;
    this.motivoEdicaoAtual = null;
    this.statusFinalizacao = '' ;
    this.ckd_ativo = 'S';
  }


  alteraModoEdicaoTipoRecusa(tipoRecusa){
    this.msgValidacao = ''
    this.modoEdicaoTipoRecusa = true;
    this.tipoRecusaEdicaoAtual = tipoRecusa;
    this.tipoRecusa = this.tipoRecusaEdicaoAtual.Descricao ;
    this.ckd_tipoRecusa = this.tipoRecusaEdicaoAtual.Ativa == 'Sim'? true: false;
  }

  cancelarEdicaoTipoRecusa(){
    this.modoEdicaoTipoRecusa = false;
    this.tipoRecusaEdicaoAtual = null;
    this.tipoRecusa = '' ;
    this.ckd_tipoRecusa = true;
  }

  alteraModoEdicaoVoltoDepois(voltoDepois){
    this.msgValidacao = ''
    this.modoEdicaoVoltoDepois = true;
    this.voltoDepoisEdicaoAtual = voltoDepois;
    this.tipoVoltoDepois = this.voltoDepoisEdicaoAtual.Descricao ;
    this.ckd_tipoVoltoDepois = this.voltoDepoisEdicaoAtual.Ativa == 'Sim'? true: false;
  }

  cancelarEdicaoVoltoDepois(){
    this.modoEdicaoVoltoDepois = false;
    this.voltoDepoisEdicaoAtual = null;
    this.tipoVoltoDepois = '' ;
    this.ckd_tipoVoltoDepois = true;
  }


  cancelarEdicao(){
    this.modoEdicao = false;
    this.usuarioEdicaoAtual = null;
    this.nomeAtendente = '';
    this.ckd_confFiltroAtivo = true;
    this.marcarTodosMotor()
  }
  
  async atualizaUsuarioOcMotor(objParam: ObjectParam ) {
    await this.popupConfigService.deleteUsuarioOCMotor(objParam.usuarioOcMotor.UsuariosMotOCID);
    if(objParam.usuarioOcMotor.listMotorID.length){
      await this.popupConfigService.inserirUsuarioOcMotor(objParam)
    }
  }


  marcarTodosMotor(){
    this.motoristas.forEach((motor) => motor.checked = true)
  }

  desmarcarTodosMotor(){
    this.motoristas.forEach((motor) => motor.checked = false)
  }

  marcarMotorUsuario(){
    this.motoristas.forEach((motorista) => {
      let motorositaSelecionado = this.usuarioEdicaoAtual.motoristas.some((usuario) => usuario.MotorID == motorista.MotorID)
      motorista.checked = motorositaSelecionado? true : false;
      return motorista
    } )
  }
}
